import Modal from 'Components/Modal/Modal';
import { useEffect, useState } from 'react';

import { ModalFileWrapper } from './styles';

type FileViewerModalProps = {
  displayFileId: string | null;
  downloadFile: (fileId: string) => Promise<{ fileUrl: string; fileType: string } | null>;
  handleFileModalClose: () => void;
};

const FileViewerModal = ({ displayFileId, downloadFile, handleFileModalClose }: FileViewerModalProps) => {
  const [displayFileUrl, setDisplayFileUrl] = useState<string | null>(null);
  const [displayFileType, setDisplayFileType] = useState<'pdf' | 'image' | null>(null);
  const [isFileLoading, setIsFileLoading] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string>('');

  useEffect(() => {
    const fetchFile = async () => {
      if (!displayFileId) return;
      setIsFileLoading(true);
      setErrorMsg('');
      const fileData = await downloadFile(displayFileId);
      if (fileData) {
        setDisplayFileUrl(fileData.fileUrl);
        setDisplayFileType(fileData.fileType === 'pdf' ? 'pdf' : 'image');
      } else {
        setErrorMsg('Error downloading file. Please try again.');
      }
      setIsFileLoading(false);
    };

    if (displayFileId) {
      fetchFile();
    }

    return () => {
      setDisplayFileUrl(null);
      setDisplayFileType(null);
      setErrorMsg('');
    };
  }, [displayFileId, downloadFile]);

  return (
    <>
      {displayFileId ? (
        <Modal
          title={`File #${displayFileId}`}
          cancelBtnText="Close"
          confirmBtnText="Open in new tab"
          hideConfirmBtn={!displayFileUrl}
          handleCancel={() => handleFileModalClose()}
          handleSubmit={(e) => {
            if (displayFileUrl) window.open(displayFileUrl, '_blank');
            e.preventDefault();
          }}
          large={true}
        >
          <ModalFileWrapper>
            {!isFileLoading && !errorMsg && !!displayFileUrl ? (
              displayFileType === 'pdf' ? (
                <embed src={displayFileUrl} type="application/pdf" width="100%" height="600px" />
              ) : (
                <img src={displayFileUrl} alt="file" />
              )
            ) : (
              <div className="loading-msg">{errorMsg ? errorMsg : 'Loading...'}</div>
            )}
          </ModalFileWrapper>
        </Modal>
      ) : (
        <></>
      )}
    </>
  );
};

export default FileViewerModal;
